import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/MikroSync";

export const MIKRO_SYNC_PREFIX_URL = PREFIX_URL;

export const GetCustomers = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetCustomers`, options);

// POST istekleri - Transfer işlemleri
export const CreateCustomer = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CreateCustomer`, options);

export default {
  // GET metodları
  GetCustomers,

  // POST metodları
  CreateCustomer,
};
